Controller = App.loadClass 'core::Angular/Controller'

class exports.AccessController extends Controller

    constructor: (@access_name, @http) ->
        # Get the user's admin pages
        @http.get 'backend/admin/access/user-pages'
        .then (response) =>
            # Check that the current page exists in the accessible pages
            if not response.data.includes(@access_name)
                # Redirect the user away from inaccessible pages
                window.location.replace('admin')
